import React from 'react';
import { Scorecard } from 'talent_matching/types';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import BaseFeedbackCell from 'talent_matching/components/shared/base_feedback_cell';

export { FeedbackItem } from 'talent_matching/components/shared/base_feedback_cell';

type Props = {
  scorecards: Scorecard[];
};

const FeedbackCell = ({ scorecards }: Props) => {
  const { setActiveSidePanelTab } = useTalentMatchingTabContext();

  return (
    <BaseFeedbackCell
      scorecards={scorecards}
      onShowMore={() => setActiveSidePanelTab('feedback')}
    />
  );
};

export default FeedbackCell;
